/**
 * 初始化租户-模块方案 ID 静态配置（接口暂未接入，前端先行存储）
 * 每个场景分 EHS / YG 两套模块 ID，按模块选择时为所选模块 ID 的并集
 */
export const MODULE_IDS = {
  // 全量开通
  all: {
    ehs: [
      '0',
      '0f82a21f-937f-4eae-ab60-eb12291c0636',
      'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823',
      'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '105f66ea-099d-4490-915f-b926fb29b43f',
      '7a5130d1-3d7b-4855-8b3b-a18fa62d881b',
      '1115c64b-e5b0-4b03-a728-cf0c570200ab',
      '687a0108-fe39-431c-bcb1-eeb507ca1a5e',
      'b6b7f329-0bdc-4764-b948-3575611dbde8',
      '5b0f66dd-5cd7-402f-b201-ed04ade7a085',
      'e64074a2-2bab-4aeb-8c7d-b832e8e1db99',
      '42d35983-d711-4f48-95d7-028ff76409f5',
      'ae96e5ae-0d9b-4019-bb4f-f64cb7f9c94c',
      '37efb1f4-f04d-44a8-ba50-808a0e09e1ab',
      '8716a6a3-af2b-4c49-97e4-f20897f708b7',
      '6e458795-dba7-4fee-ac2d-2018acfbe71d',
      'db3ac6b3-ae00-4c93-9edf-1b5b969f3d3b',
      '7354420d-4ba5-4341-97c3-07ffd800bda8',
      'e99adbe3-6214-4b07-845e-c23638429905',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4',
      '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd',
      '21397d2f-1669-4331-b53c-61c216cc4a5c',
      '03c92f6d-d103-462f-b461-097c33781dfb',
      'f153c4fb-991f-4b36-a8d8-f339338d300a',
      'b847c890-f0a3-4673-b220-2bb343610696',
      '5f1759b1-76fb-4b56-8ddf-3e5deba766a1',
      '99188c5b-1fe8-406b-95cd-d0fd1556a15e',
      '969c911c-091e-458c-83cd-5f85e28d19b0',
      'b5b1b9ed-7903-4172-8ea6-a4e58cf24483',
      'bde3a2fa-b129-4d8d-b5fc-3609016e5703',
      '9b9ccc1e-bc5c-4e3f-a3ee-a870bda87ec0',
      'd6f844dd-d09a-48f0-a9cd-76f8d2c1ff62',
      '526a31f6-1dda-4055-8471-d82f0a93e581',
      '3c45a366-adc5-4d3a-b09c-a982d30a12f5',
      'e30ddbcf-7eff-4a5c-a09b-0991b7022680',
      'f977aee9-e47f-4071-a622-b8244ce99e4f',
      '13d4d5ca-bb7a-4cac-a336-318bdcf3ac09',
      '93495ca7-9b2d-4c5b-9305-e1d108fbb1fa',
      '9a2d4f58-a117-425d-b7ef-d95a6c45ab38',
      'dbf20f3b-f9f8-4539-b8c6-f158d3c63df3',
      '61c85cae-075b-49ad-ad8d-84d61174bb56',
      'fcae4971-dfc0-4340-b446-cff272515e4a',
      '80aa0774-dba1-451f-8869-1290fc82f626',
      '8a3b39b1-9286-49c9-9daa-e35e6803bc05',
      '15920097-d20b-4ffe-a9fc-f80cdd5fda5b',
      '1ec6e634-fc94-49b1-bbc2-d43ae38b115c',
      '00abc9f5-1361-49c0-ba32-1623567140a8',
      'a87a5b1f-3529-49de-b310-ec04a29ed248',
      '88cd519d-6a49-4a8c-89ad-d7f69c2ca1d8',
      '06a1b09a-4c33-46b1-b725-46a3e5162a44',
      'd8b777f5-f696-4aa3-8ebc-c3c99f1917a5',
      '6d9fa9e8-6b36-492e-9bb9-5285253c3eb0',
      '3f33ed80-1bb1-42cd-b16a-1e28ba175d5f',
      '819a395e-4fd9-42f7-a874-3df3cd037307',
      'f8a71a99-72a2-4e62-b480-eb4a7add503e',
      '2c2c330f-f8b5-4593-9063-440f1878bf38',
      'f13e4c5a-97b3-4bcd-b002-d7dc888416f5',
      'cff5f1c7-7e7f-4cf2-a992-f387383654b9',
      '8eadab38-60e2-4e16-bf4b-1f1ea307f098',
      'f5a75e1d-ef46-4fc9-8720-c6c8c3593421',
      '3c933e3b-7354-46c6-82c7-77d5f5a13b8b',
      'd31d8ce0-5ecd-4094-9063-73dfde61424d',
      '304766c7-c697-49b0-85db-d958536240ce',
      'c95185d1-7c94-420b-be6e-5a41571aaf73',
      '2c0cbbf0-c062-421f-9a8e-4a60faf06a02',
      'b5a773a5-f491-417c-a891-1faa0e00420f',
      'e96c2d60-7c15-4ece-b7b9-4b6194957740',
      'c32344e0-4a59-4e19-9d41-063d00d834fb',
      'b7f8ea41-b56c-48e8-a4be-d9596f7ec0a7',
      '7c5b441a-6824-4f17-b561-34f68a91b9d9',
      '57d9e7cf-eb9e-4f8e-a2b1-f81552f9ecdb',
      'c3015838-78d3-4355-9527-0740fd36f26d',
      '8be2ada4-36f5-4403-b7ba-e019e3fabd77',
      '6faa96f0-856f-408c-ae89-a501cfef99a6',
      '4c22bd2c-8f38-4eb5-a874-60da6e24278c',
      '8121075b-8444-4039-8c97-21dbc77c5554',
      '09b33bda-542b-4c14-9aa0-228816b594bb',
      '2a59592c-7c64-4638-afef-dc0a3be0c83c',
      '828c74ec-4965-4a73-9457-b0fd860fd79e',
      'bfe0b87b-4f50-438d-8a90-31f4c9836d8d',
      'a76b4e32-dc5c-4bae-a049-3ce059be9727',
      '46a40fc3-19e7-44b3-830a-652658c0b0fe',
      'cab78b94-665f-40b7-bb5e-a832e4bf381f',
      '0205c3e9-f1a7-4e33-b789-9a30fe74e1b3',
      'f2401147-8265-44a0-bad3-19853b88871b',
      '6f36f06b-0385-45a4-9c25-1566b5cf6cac',
      'efc3a46e-5e5a-4e5b-84a8-4af40acf9c75',
      '11b8feac-dda0-42dc-bb1a-1a44175b1660',
      '6bfe7a9d-8215-4f63-a9cd-8e0f5404ecf8',
      'ff172bae-4800-48af-a767-0c9fbacc46b4',
      '3196a533-7c81-4797-9b72-a9f1f04f7168',
      'c85bcbe1-29ab-435b-96b7-dc95e5b5b6a2',
      '8bcaa007-a79b-4ebc-8482-92af36de7a0d',
      'a45f1005-0628-4eee-84e0-24cf0bc7c5c6',
      '44d529bd-4968-41fd-a6b8-6d6ac56f75e9',
      'dd0d66c6-d2e0-4c7a-a866-7583cbb2e527',
      '42b45529-5e9f-44bf-976d-5caccd1b8801',
      '4b278d12-0a13-4886-99dc-f233c9237a52',
      '083f8f99-f2e1-4a41-a2fb-d897c25aa97f',
      'a5dbc972-d39a-4bf7-a308-38eb28cf5264',
      '6bfbbc3b-4c7d-4f6d-b484-c686790d303a',
      'f0790f03-d23b-4734-80b6-646a57a04544',
      'b83c38d6-ddda-4fe7-b6db-d82a181a7a9d',
      '7e849c9a-21bc-405e-9bdc-ad63a58b4c33',
      '70b641fd-9096-4bc4-8ac0-93af49853c68',
      '83d5b977-1cec-412f-8e64-08d703e326b9',
      'be264c37-b0cc-44a9-8de1-73f56108cfce',
      '5d3c5305-a66c-4052-8ff7-6d9a49434259',
      'c97e2dec-bf6d-4e37-b3fb-99f6e26a781b',
      'b14479f7-cb3e-4177-a3b1-56f1db269b9a',
      '911d6205-2e04-4f03-b88d-89dda2eef08b',
      '248f6609-cf85-4756-9578-47484392b553',
      'aeb8edad-216b-46a7-87bf-e4cbfbbe53cf',
      '2c06d6b0-9c63-44af-96d9-a08c346bf228',
      'd86ac253-a50f-434f-bba9-9e44fc8fe401',
      '8eb87412-170b-4111-a32a-d339e53cee69',
      '23cf0e5b-32e3-4533-bb87-dfe66302729e',
      '28bc4337-ce6c-42d4-aff7-37c4e9f8b228',
      'a91840b5-b80f-404e-9a34-9e3bd9886e44',
      '93da3391-b110-454b-bc2c-c16a83548eb7',
      '451590fa-22de-4b7c-a1dd-092dd7b94375',
      'a2eeeeb4-e837-4165-9e4f-94bdc3328616',
      '19a52a82-22d0-4c19-8357-aed79c45fa45',
      '4e03ab3e-8e8f-474f-95e0-e788a9aab6bc',
      '922cb427-11b8-4ffe-b25b-967ab7d5a61f',
      '0913f27a-02c9-4560-972a-aec0732a98c4',
      'b554f616-9a0e-4964-b6ad-e9a1fc3a4d67',
      'b6576802-b26c-47e1-9021-58375ce30b4b',
      'f07728ae-0831-4c39-98ea-5d23cd188960',
      '387ce558-3a96-4a1e-ad03-718ca3e72136',
      'a6f75ba1-50ab-4a72-9c3b-657fd1bd480d',
      '82f9acf8-5e0d-4a87-81cb-8623743c155a',
      'a2ec079a-7a61-4961-89a9-0624224785f2',
      '120dadcc-3ef1-4f55-9aad-e51ff10a0266',
      'b12ef151-ac08-4e11-a63e-135764e6c7ae',
      '78be7629-6d36-4a7d-8f1f-e0052001bea4',
      'dd4bcef7-85a3-48b0-bcda-f09fb25c2726',
      '79d70abd-56ea-43a8-a6c6-538a36382aa3',
      '69cc2956-a4d6-4293-9fef-2cc1fe0d9e5f',
      '01b47cd3-4e35-4e0f-af3a-acfbc06f8e87',
      'c35a7398-1b28-4ac2-b15f-fe0cb64ce8f2',
      '09e39ca2-901b-4633-bdf4-fc142350c592',
      '2e795a9b-f0d4-413f-ab30-7e37c6ee6a71',
      '82f28023-1d3b-4a7f-adfb-4d3f9b5c0707',
      '59baf627-ee06-4897-b76d-0e47106eddc9',
      '112cf584-a8b1-481a-ac34-94ea9780291c',
      'b82cef89-a398-4555-8f46-526a767ed7ad',
      '2de05e77-48d7-4fc3-99d4-02074401d4b6',
      'b7e2131d-e1a7-4e31-afdc-9247568f7a69',
      'f9a886a5-c25b-4ade-b2d8-f56019f936d2',
      '508d4da5-12e5-4dfb-b752-71e152eee366',
      'be60b55d-8d57-4d95-bf84-f18bee16db0b',
      '30d0ce8c-95bd-4f00-88ec-d23960538f92',
      'a8045316-67a7-41d1-99a6-90780d9dfc75',
      'bf73d609-ed56-46a6-9ad8-dbaa01ba7837',
      'a470365d-5e44-40b8-898d-fdc1307aa92c',
      'ff62778d-377c-43b2-8502-960381f693f2',
      '441715ea-92fa-455b-86d1-f51b6a1aea80',
      '2356b389-7554-4a78-bbe3-06d5e3d8e310',
      'cc383494-8036-47a0-b9fe-2c3a1735b711',
      '643bd291-8930-41e7-88de-44c32a097040',
      '235252a1-2898-40df-8f3c-fe6d1eadbfe3',
      'a01ec0a9-d126-4208-894e-153924242f62',
      'a505293c-00e0-4943-88d2-c7de8cd89ac1',
      '76ef3a5a-9c47-4ae8-a445-1c70d5c94d1d',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '7743a006-685f-4ad5-9aae-019ba982b08d',
      'caa5995b-a3f9-430e-b3d9-9376e480f366',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'fcd017fd-a992-4bfb-842e-d4864ebaf518',
      '795f98a6-ec67-49ff-885c-985a6beea878',
      'f5f4455f-ec8a-44f4-a0cd-586be77e6e90',
      'ce8f76ad-dfee-400e-a081-1d6b34879394',
      '9e06469a-839b-4a86-972a-0d207387b3ce',
      '5574ef61-3e50-4bb5-a25d-6093703d83f8',
      'ea2e16a2-a0d9-4449-a3f8-5cdb840cf249',
      '82537ade-86c7-49ae-aec5-4d87967f9659',
      'f5974994-bac6-446c-98ee-ea4d929cb516',
      '3dd7fed6-0fcf-4dd2-8500-e1cb0306a8ee',
      'e14f5a32-f69d-408d-8b9d-2e9b3a63325a',
      'c31ba295-1e72-46ae-952c-6efb24c08dab',
      '01f5e453-89ca-470a-a5c7-49f474e638a9',
      '940fa212-d9af-4154-8b5c-acda1bb1b3fb',
      '2f8d30bf-b7d5-4106-b7ae-99dc86bf429b',
      '98a86494-b1ca-4f7b-b03e-becc4da73bcd',
      'a42f01e0-5328-4f8d-a240-3248ac5f19a5',
      'c9a750f2-d241-4065-8c9b-1e1897399a44',
      '9d3a4e53-0e4b-4573-99e3-8e3bf2f6f835',
      '65129732-c0dc-4b85-8e0c-c1f0d11af277',
      '992911d6-a21a-4eb6-b072-7efbca2c74be',
      'e7523c43-9d59-49e1-b9e4-3487fc74079e',
      '8636f0d7-af8c-4ace-abcd-fe3a83a386cf',
      '4041f5fd-f882-426d-988c-08874acd3758',
      'fc81afd5-aa3d-4e13-ac56-2c8d9bdaf549',
      '98c1222f-39de-4ced-ae35-eaa34668b2a0',
      '6dea061f-9a39-4a48-b956-077badddd6e5',
      'c9698859-dcd4-44f3-b8fd-38fd083a2bc0',
      '26c68532-6818-4b10-8f32-fc4fa854f464',
      '29285ede-498a-4e48-83cd-f54daaf3b250',
      'e46ccb17-2fac-45d0-be42-587a3c5a9f9a',
      '029c5455-d80f-4c46-94ed-48064c58fb21',
      '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7',
      'b167cf5b-6d17-496f-a8ea-b16132d5b179',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe',
      '207c8f95-9433-4f85-801e-385373f28512',
      'a91f9994-d5ef-4e8c-b3d1-40a33c090b51',
      '7c08bf7f-27d3-4833-ac87-ee12dc99c5fb'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'fcd017fd-a992-4bfb-842e-d4864ebaf518',
      '795f98a6-ec67-49ff-885c-985a6beea878',
      'f5f4455f-ec8a-44f4-a0cd-586be77e6e90',
      'ce8f76ad-dfee-400e-a081-1d6b34879394',
      '9e06469a-839b-4a86-972a-0d207387b3ce',
      '5574ef61-3e50-4bb5-a25d-6093703d83f8',
      'ea2e16a2-a0d9-4449-a3f8-5cdb840cf249',
      '82537ade-86c7-49ae-aec5-4d87967f9659',
      'f5974994-bac6-446c-98ee-ea4d929cb516',
      '3dd7fed6-0fcf-4dd2-8500-e1cb0306a8ee',
      'e14f5a32-f69d-408d-8b9d-2e9b3a63325a',
      'c31ba295-1e72-46ae-952c-6efb24c08dab',
      '01f5e453-89ca-470a-a5c7-49f474e638a9',
      '940fa212-d9af-4154-8b5c-acda1bb1b3fb',
      'a42f01e0-5328-4f8d-a240-3248ac5f19a5',
      'c9a750f2-d241-4065-8c9b-1e1897399a44',
      '9d3a4e53-0e4b-4573-99e3-8e3bf2f6f835',
      '65129732-c0dc-4b85-8e0c-c1f0d11af277',
      '992911d6-a21a-4eb6-b072-7efbca2c74be',
      'e7523c43-9d59-49e1-b9e4-3487fc74079e',
      '8636f0d7-af8c-4ace-abcd-fe3a83a386cf',
      '4041f5fd-f882-426d-988c-08874acd3758',
      'fc81afd5-aa3d-4e13-ac56-2c8d9bdaf549',
      '98c1222f-39de-4ced-ae35-eaa34668b2a0',
      '6dea061f-9a39-4a48-b956-077badddd6e5',
      'c9698859-dcd4-44f3-b8fd-38fd083a2bc0',
      '26c68532-6818-4b10-8f32-fc4fa854f464',
      '29285ede-498a-4e48-83cd-f54daaf3b250',
      'e46ccb17-2fac-45d0-be42-587a3c5a9f9a',
      '029c5455-d80f-4c46-94ed-48064c58fb21',
      '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7',
      'b167cf5b-6d17-496f-a8ea-b16132d5b179',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe',
      '207c8f95-9433-4f85-801e-385373f28512',
      'a91f9994-d5ef-4e8c-b3d1-40a33c090b51',
      '7c08bf7f-27d3-4833-ac87-ee12dc99c5fb'
    ]
  },
  // 隐患
  hazard: {
    ehs: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      'e64074a2-2bab-4aeb-8c7d-b832e8e1db99', '42d35983-d711-4f48-95d7-028ff76409f5',
      'ae96e5ae-0d9b-4019-bb4f-f64cb7f9c94c', '37efb1f4-f04d-44a8-ba50-808a0e09e1ab',
      '8716a6a3-af2b-4c49-97e4-f20897f708b7', '6e458795-dba7-4fee-ac2d-2018acfbe71d',
      'db3ac6b3-ae00-4c93-9edf-1b5b969f3d3b', 'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4',
      '88473424-f1f7-4134-911c-7cac16f329f8', 'df8009a1-3784-4642-93d5-99130430b0bd',
      '21397d2f-1669-4331-b53c-61c216cc4a5c', 'b847c890-f0a3-4673-b220-2bb343610696',
      '5f1759b1-76fb-4b56-8ddf-3e5deba766a1', '922cb427-11b8-4ffe-b25b-967ab7d5a61f',
      '0913f27a-02c9-4560-972a-aec0732a98c4', 'b554f616-9a0e-4964-b6ad-e9a1fc3a4d67',
      'b6576802-b26c-47e1-9021-58375ce30b4b', 'f07728ae-0831-4c39-98ea-5d23cd188960',
      '387ce558-3a96-4a1e-ad03-718ca3e72136', 'a6f75ba1-50ab-4a72-9c3b-657fd1bd480d',
      '82f9acf8-5e0d-4a87-81cb-8623743c155a', 'a2ec079a-7a61-4961-89a9-0624224785f2',
      '120dadcc-3ef1-4f55-9aad-e51ff10a0266', 'b12ef151-ac08-4e11-a63e-135764e6c7ae',
      '78be7629-6d36-4a7d-8f1f-e0052001bea4', 'dd4bcef7-85a3-48b0-bcda-f09fb25c2726',
      '79d70abd-56ea-43a8-a6c6-538a36382aa3', '69cc2956-a4d6-4293-9fef-2cc1fe0d9e5f',
      '01b47cd3-4e35-4e0f-af3a-acfbc06f8e87', 'c35a7398-1b28-4ac2-b15f-fe0cb64ce8f2',
      '09e39ca2-901b-4633-bdf4-fc142350c592', '2e795a9b-f0d4-413f-ab30-7e37c6ee6a71',
      '82f28023-1d3b-4a7f-adfb-4d3f9b5c0707', '59baf627-ee06-4897-b76d-0e47106eddc9',
      '112cf584-a8b1-481a-ac34-94ea9780291c', 'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547', 'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f', 'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4', 'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f', '7743a006-685f-4ad5-9aae-019ba982b08d',
      'caa5995b-a3f9-430e-b3d9-9376e480f366', '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      '6dea061f-9a39-4a48-b956-077badddd6e5', 'c9698859-dcd4-44f3-b8fd-38fd083a2bc0',
      '26c68532-6818-4b10-8f32-fc4fa854f464', '29285ede-498a-4e48-83cd-f54daaf3b250',
      'e46ccb17-2fac-45d0-be42-587a3c5a9f9a', '029c5455-d80f-4c46-94ed-48064c58fb21',
      '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7', 'b167cf5b-6d17-496f-a8ea-b16132d5b179'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', '6dea061f-9a39-4a48-b956-077badddd6e5',
      '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7', 'b167cf5b-6d17-496f-a8ea-b16132d5b179',
      'c9698859-dcd4-44f3-b8fd-38fd083a2bc0', '26c68532-6818-4b10-8f32-fc4fa854f464',
      '29285ede-498a-4e48-83cd-f54daaf3b250', 'e46ccb17-2fac-45d0-be42-587a3c5a9f9a',
      '029c5455-d80f-4c46-94ed-48064c58fb21'
    ]
  },
  // 培训
  train: {
    ehs: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '7024578a-09a3-4df5-9d5a-f6060075539a', '0e026a8d-3cf6-46cc-bea8-0d9affaa211b',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4', '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd', '21397d2f-1669-4331-b53c-61c216cc4a5c',
      'b847c890-f0a3-4673-b220-2bb343610696', '5f1759b1-76fb-4b56-8ddf-3e5deba766a1',
      '668e4f8d-f77a-4b08-8450-70c45fc9ca1e', 'ba5a4055-588d-4ba2-b39a-887b041e8607',
      '0b3306d4-9c89-4a0f-87f5-e856bc3a84d0', '9be47656-db25-4b39-a2a3-32eea8f934b5',
      '9ddb1fcd-1135-45cb-b569-0102f5835c28', '6541fe04-1383-46a2-ab79-131d8dde337b',
      '67cce002-c348-4600-ae71-21b9755c83a0', 'bb880cb3-4164-412b-99df-93e0eb9684e9',
      '85a1c4f1-8555-47e6-9eee-049e3981e09f', 'cbba9161-144e-424d-8f83-c3d59bf38174',
      'fb282607-828f-4ff2-a605-b8208d098fe0', 'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547', 'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f', 'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4', 'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f', '7743a006-685f-4ad5-9aae-019ba982b08d',
      'caa5995b-a3f9-430e-b3d9-9376e480f366', '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2', 'd9bf5b8c-5543-4f5c-9066-7bde318b9bac',
      '07af2973-70a0-48af-a422-55ab070454e9'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', 'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'd9bf5b8c-5543-4f5c-9066-7bde318b9bac', '07af2973-70a0-48af-a422-55ab070454e9'
    ]
  },
  // 培训（新）
  trainNew: {
    ehs: [
      '0',
      '0f82a21f-937f-4eae-ab60-eb12291c0636',
      'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823',
      'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '7354420d-4ba5-4341-97c3-07ffd800bda8',
      'e99adbe3-6214-4b07-845e-c23638429905',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4',
      '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd',
      '21397d2f-1669-4331-b53c-61c216cc4a5c',
      'b847c890-f0a3-4673-b220-2bb343610696',
      '5f1759b1-76fb-4b56-8ddf-3e5deba766a1',
      'b82cef89-a398-4555-8f46-526a767ed7ad',
      '2de05e77-48d7-4fc3-99d4-02074401d4b6',
      'b7e2131d-e1a7-4e31-afdc-9247568f7a69',
      'f9a886a5-c25b-4ade-b2d8-f56019f936d2',
      '508d4da5-12e5-4dfb-b752-71e152eee366',
      'be60b55d-8d57-4d95-bf84-f18bee16db0b',
      '30d0ce8c-95bd-4f00-88ec-d23960538f92',
      'a8045316-67a7-41d1-99a6-90780d9dfc75',
      'bf73d609-ed56-46a6-9ad8-dbaa01ba7837',
      'a470365d-5e44-40b8-898d-fdc1307aa92c',
      'ff62778d-377c-43b2-8502-960381f693f2',
      '441715ea-92fa-455b-86d1-f51b6a1aea80',
      '2356b389-7554-4a78-bbe3-06d5e3d8e310',
      'cc383494-8036-47a0-b9fe-2c3a1735b711',
      '643bd291-8930-41e7-88de-44c32a097040',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '7743a006-685f-4ad5-9aae-019ba982b08d',
      'caa5995b-a3f9-430e-b3d9-9376e480f366',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe'
    ]
  },
  // 作业
  work: {
    ehs: [
      '0',
      '0f82a21f-937f-4eae-ab60-eb12291c0636',
      'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823',
      'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      'b6b7f329-0bdc-4764-b948-3575611dbde8',
      '5b0f66dd-5cd7-402f-b201-ed04ade7a085',
      '8716a6a3-af2b-4c49-97e4-f20897f708b7',
      '6e458795-dba7-4fee-ac2d-2018acfbe71d',
      'db3ac6b3-ae00-4c93-9edf-1b5b969f3d3b',
      '7354420d-4ba5-4341-97c3-07ffd800bda8',
      'e99adbe3-6214-4b07-845e-c23638429905',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4',
      '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd',
      '21397d2f-1669-4331-b53c-61c216cc4a5c',
      '03c92f6d-d103-462f-b461-097c33781dfb',
      'f153c4fb-991f-4b36-a8d8-f339338d300a',
      'b847c890-f0a3-4673-b220-2bb343610696',
      '5f1759b1-76fb-4b56-8ddf-3e5deba766a1',
      'efc3a46e-5e5a-4e5b-84a8-4af40acf9c75',
      '11b8feac-dda0-42dc-bb1a-1a44175b1660',
      '6bfe7a9d-8215-4f63-a9cd-8e0f5404ecf8',
      'ff172bae-4800-48af-a767-0c9fbacc46b4',
      '3196a533-7c81-4797-9b72-a9f1f04f7168',
      'c85bcbe1-29ab-435b-96b7-dc95e5b5b6a2',
      'be264c37-b0cc-44a9-8de1-73f56108cfce',
      '5d3c5305-a66c-4052-8ff7-6d9a49434259',
      'c97e2dec-bf6d-4e37-b3fb-99f6e26a781b',
      'b14479f7-cb3e-4177-a3b1-56f1db269b9a',
      '911d6205-2e04-4f03-b88d-89dda2eef08b',
      '248f6609-cf85-4756-9578-47484392b553',
      'aeb8edad-216b-46a7-87bf-e4cbfbbe53cf',
      '2c06d6b0-9c63-44af-96d9-a08c346bf228',
      'd86ac253-a50f-434f-bba9-9e44fc8fe401',
      '8eb87412-170b-4111-a32a-d339e53cee69',
      '23cf0e5b-32e3-4533-bb87-dfe66302729e',
      '28bc4337-ce6c-42d4-aff7-37c4e9f8b228',
      'a91840b5-b80f-404e-9a34-9e3bd9886e44',
      '93da3391-b110-454b-bc2c-c16a83548eb7',
      '451590fa-22de-4b7c-a1dd-092dd7b94375',
      'a2eeeeb4-e837-4165-9e4f-94bdc3328616',
      '19a52a82-22d0-4c19-8357-aed79c45fa45',
      '4e03ab3e-8e8f-474f-95e0-e788a9aab6bc',
      '922cb427-11b8-4ffe-b25b-967ab7d5a61f',
      'a2ec079a-7a61-4961-89a9-0624224785f2',
      '120dadcc-3ef1-4f55-9aad-e51ff10a0266',
      'b12ef151-ac08-4e11-a63e-135764e6c7ae',
      '01b47cd3-4e35-4e0f-af3a-acfbc06f8e87',
      'c35a7398-1b28-4ac2-b15f-fe0cb64ce8f2',
      '09e39ca2-901b-4633-bdf4-fc142350c592',
      '2e795a9b-f0d4-413f-ab30-7e37c6ee6a71',
      'b82cef89-a398-4555-8f46-526a767ed7ad',
      '2de05e77-48d7-4fc3-99d4-02074401d4b6',
      'b7e2131d-e1a7-4e31-afdc-9247568f7a69',
      'f9a886a5-c25b-4ade-b2d8-f56019f936d2',
      '508d4da5-12e5-4dfb-b752-71e152eee366',
      'be60b55d-8d57-4d95-bf84-f18bee16db0b',
      '30d0ce8c-95bd-4f00-88ec-d23960538f92',
      'a8045316-67a7-41d1-99a6-90780d9dfc75',
      'bf73d609-ed56-46a6-9ad8-dbaa01ba7837',
      'a470365d-5e44-40b8-898d-fdc1307aa92c',
      'ff62778d-377c-43b2-8502-960381f693f2',
      '441715ea-92fa-455b-86d1-f51b6a1aea80',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '7743a006-685f-4ad5-9aae-019ba982b08d',
      'caa5995b-a3f9-430e-b3d9-9376e480f366',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'c31ba295-1e72-46ae-952c-6efb24c08dab',
      'a42f01e0-5328-4f8d-a240-3248ac5f19a5',
      'c9a750f2-d241-4065-8c9b-1e1897399a44',
      '9d3a4e53-0e4b-4573-99e3-8e3bf2f6f835',
      '65129732-c0dc-4b85-8e0c-c1f0d11af277',
      '992911d6-a21a-4eb6-b072-7efbca2c74be',
      'e7523c43-9d59-49e1-b9e4-3487fc74079e',
      '8636f0d7-af8c-4ace-abcd-fe3a83a386cf',
      '4041f5fd-f882-426d-988c-08874acd3758',
      'fc81afd5-aa3d-4e13-ac56-2c8d9bdaf549',
      '98c1222f-39de-4ced-ae35-eaa34668b2a0',
      '6dea061f-9a39-4a48-b956-077badddd6e5',
      '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7',
      'b167cf5b-6d17-496f-a8ea-b16132d5b179',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe'
    ],
    yg: [
      '0',
      '0f82a21f-937f-4eae-ab60-eb12291c0636',
      'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '7354420d-4ba5-4341-97c3-07ffd800bda8',
      'e99adbe3-6214-4b07-845e-c23638429905',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'c31ba295-1e72-46ae-952c-6efb24c08dab',
      'a42f01e0-5328-4f8d-a240-3248ac5f19a5',
      'c9a750f2-d241-4065-8c9b-1e1897399a44',
      '992911d6-a21a-4eb6-b072-7efbca2c74be',
      'e7523c43-9d59-49e1-b9e4-3487fc74079e',
      '6dea061f-9a39-4a48-b956-077badddd6e5',
      '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7',
      'b167cf5b-6d17-496f-a8ea-b16132d5b179',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe'
    ]
  },
  // 巡检
  inspect: {
    ehs: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '8716a6a3-af2b-4c49-97e4-f20897f708b7', '6e458795-dba7-4fee-ac2d-2018acfbe71d',
      'db3ac6b3-ae00-4c93-9edf-1b5b969f3d3b', 'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4',
      '88473424-f1f7-4134-911c-7cac16f329f8', 'df8009a1-3784-4642-93d5-99130430b0bd',
      '21397d2f-1669-4331-b53c-61c216cc4a5c', 'b847c890-f0a3-4673-b220-2bb343610696',
      '5f1759b1-76fb-4b56-8ddf-3e5deba766a1', 'efc3a46e-5e5a-4e5b-84a8-4af40acf9c75',
      '8bcaa007-a79b-4ebc-8482-92af36de7a0d', 'a45f1005-0628-4eee-84e0-24cf0bc7c5c6',
      '44d529bd-4968-41fd-a6b8-6d6ac56f75e9', 'dd0d66c6-d2e0-4c7a-a866-7583cbb2e527',
      '42b45529-5e9f-44bf-976d-5caccd1b8801', '4b278d12-0a13-4886-99dc-f233c9237a52',
      '083f8f99-f2e1-4a41-a2fb-d897c25aa97f', 'a5dbc972-d39a-4bf7-a308-38eb28cf5264',
      '6bfbbc3b-4c7d-4f6d-b484-c686790d303a', 'f0790f03-d23b-4734-80b6-646a57a04544',
      'b83c38d6-ddda-4fe7-b6db-d82a181a7a9d', '7e849c9a-21bc-405e-9bdc-ad63a58b4c33',
      '70b641fd-9096-4bc4-8ac0-93af49853c68', '83d5b977-1cec-412f-8e64-08d703e326b9',
      '922cb427-11b8-4ffe-b25b-967ab7d5a61f', 'a2ec079a-7a61-4961-89a9-0624224785f2',
      '120dadcc-3ef1-4f55-9aad-e51ff10a0266', 'b12ef151-ac08-4e11-a63e-135764e6c7ae',
      '01b47cd3-4e35-4e0f-af3a-acfbc06f8e87', 'c35a7398-1b28-4ac2-b15f-fe0cb64ce8f2',
      '09e39ca2-901b-4633-bdf4-fc142350c592', '2e795a9b-f0d4-413f-ab30-7e37c6ee6a71',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e', '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b', '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432', 'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4', 'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '7743a006-685f-4ad5-9aae-019ba982b08d', 'caa5995b-a3f9-430e-b3d9-9376e480f366',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', 'c31ba295-1e72-46ae-952c-6efb24c08dab',
      '01f5e453-89ca-470a-a5c7-49f474e638a9', '940fa212-d9af-4154-8b5c-acda1bb1b3fb',
      '2f8d30bf-b7d5-4106-b7ae-99dc86bf429b', '98a86494-b1ca-4f7b-b03e-becc4da73bcd',
      '6dea061f-9a39-4a48-b956-077badddd6e5', '3a914ab6-7f0b-4ebe-82ec-4c2a8f3701e7',
      'b167cf5b-6d17-496f-a8ea-b16132d5b179'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', 'c31ba295-1e72-46ae-952c-6efb24c08dab',
      '01f5e453-89ca-470a-a5c7-49f474e638a9', '940fa212-d9af-4154-8b5c-acda1bb1b3fb'
    ]
  },
  // 演练
  drill: {
    ehs: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4', '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd', '21397d2f-1669-4331-b53c-61c216cc4a5c',
      '15920097-d20b-4ffe-a9fc-f80cdd5fda5b', '1ec6e634-fc94-49b1-bbc2-d43ae38b115c',
      '00abc9f5-1361-49c0-ba32-1623567140a8', 'a87a5b1f-3529-49de-b310-ec04a29ed248',
      '88cd519d-6a49-4a8c-89ad-d7f69c2ca1d8', '06a1b09a-4c33-46b1-b725-46a3e5162a44',
      'd8b777f5-f696-4aa3-8ebc-c3c99f1917a5', '6d9fa9e8-6b36-492e-9bb9-5285253c3eb0',
      '3f33ed80-1bb1-42cd-b16a-1e28ba175d5f', '819a395e-4fd9-42f7-a874-3df3cd037307',
      'f8a71a99-72a2-4e62-b480-eb4a7add503e', 'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547', 'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f', 'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4', 'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f', '7743a006-685f-4ad5-9aae-019ba982b08d',
      'caa5995b-a3f9-430e-b3d9-9376e480f366'
    ],
    yg: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79'
    ]
  },
  // 事故
  accident: {
    ehs: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4', '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd', '21397d2f-1669-4331-b53c-61c216cc4a5c',
      '2c2c330f-f8b5-4593-9063-440f1878bf38', 'f13e4c5a-97b3-4bcd-b002-d7dc888416f5',
      'cff5f1c7-7e7f-4cf2-a992-f387383654b9', 'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547', 'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f', 'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4', 'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f', '7743a006-685f-4ad5-9aae-019ba982b08d'
    ],
    yg: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79'
    ]
  },
  // 访客预约
  visit: {
    ehs: [
      '0',
      '0f82a21f-937f-4eae-ab60-eb12291c0636',
      'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823',
      'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '1115c64b-e5b0-4b03-a728-cf0c570200ab',
      '687a0108-fe39-431c-bcb1-eeb507ca1a5e',
      '7354420d-4ba5-4341-97c3-07ffd800bda8',
      'e99adbe3-6214-4b07-845e-c23638429905',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4',
      '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd',
      '21397d2f-1669-4331-b53c-61c216cc4a5c',
      'c32344e0-4a59-4e19-9d41-063d00d834fb',
      'b7f8ea41-b56c-48e8-a4be-d9596f7ec0a7',
      '7c5b441a-6824-4f17-b561-34f68a91b9d9',
      '57d9e7cf-eb9e-4f8e-a2b1-f81552f9ecdb',
      'c3015838-78d3-4355-9527-0740fd36f26d',
      'efc3a46e-5e5a-4e5b-84a8-4af40acf9c75',
      '11b8feac-dda0-42dc-bb1a-1a44175b1660',
      '6bfe7a9d-8215-4f63-a9cd-8e0f5404ecf8',
      'ff172bae-4800-48af-a767-0c9fbacc46b4',
      '3196a533-7c81-4797-9b72-a9f1f04f7168',
      'c85bcbe1-29ab-435b-96b7-dc95e5b5b6a2',
      'b82cef89-a398-4555-8f46-526a767ed7ad',
      '2de05e77-48d7-4fc3-99d4-02074401d4b6',
      'b7e2131d-e1a7-4e31-afdc-9247568f7a69',
      'f9a886a5-c25b-4ade-b2d8-f56019f936d2',
      '508d4da5-12e5-4dfb-b752-71e152eee366',
      'be60b55d-8d57-4d95-bf84-f18bee16db0b',
      '30d0ce8c-95bd-4f00-88ec-d23960538f92',
      'a8045316-67a7-41d1-99a6-90780d9dfc75',
      'bf73d609-ed56-46a6-9ad8-dbaa01ba7837',
      'a470365d-5e44-40b8-898d-fdc1307aa92c',
      'ff62778d-377c-43b2-8502-960381f693f2',
      '441715ea-92fa-455b-86d1-f51b6a1aea80',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e',
      '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b',
      '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432',
      'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4',
      'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'fcd017fd-a992-4bfb-842e-d4864ebaf518',
      '3dd7fed6-0fcf-4dd2-8500-e1cb0306a8ee',
      'e14f5a32-f69d-408d-8b9d-2e9b3a63325a',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe'
    ],
    yg: [
      '0',
      '0f82a21f-937f-4eae-ab60-eb12291c0636',
      'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823',
      'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '1115c64b-e5b0-4b03-a728-cf0c570200ab',
      '687a0108-fe39-431c-bcb1-eeb507ca1a5e',
      '7354420d-4ba5-4341-97c3-07ffd800bda8',
      'e99adbe3-6214-4b07-845e-c23638429905',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7',
      'fcd017fd-a992-4bfb-842e-d4864ebaf518',
      '3dd7fed6-0fcf-4dd2-8500-e1cb0306a8ee',
      'e14f5a32-f69d-408d-8b9d-2e9b3a63325a',
      'e99b1cc4-f460-4c0e-9119-be37387c2dd2',
      'e4e4c404-5a70-4444-9a11-9ad78fafb952',
      '382548e3-10cc-4a82-9262-a10e4b249dbe'
    ]
  },
  // 查询中心
  query: {
    ehs: [
      '0', 'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4', '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd', '21397d2f-1669-4331-b53c-61c216cc4a5c',
      '235252a1-2898-40df-8f3c-fe6d1eadbfe3', 'a01ec0a9-d126-4208-894e-153924242f62',
      'a505293c-00e0-4943-88d2-c7de8cd89ac1', '76ef3a5a-9c47-4ae8-a445-1c70d5c94d1d',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e', '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b', '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432', 'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4', 'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '7743a006-685f-4ad5-9aae-019ba982b08d', 'caa5995b-a3f9-430e-b3d9-9376e480f366',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', '207c8f95-9433-4f85-801e-385373f28512',
      'a91f9994-d5ef-4e8c-b3d1-40a33c090b51', '7c08bf7f-27d3-4833-ac87-ee12dc99c5fb'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', '207c8f95-9433-4f85-801e-385373f28512',
      'a91f9994-d5ef-4e8c-b3d1-40a33c090b51', '7c08bf7f-27d3-4833-ac87-ee12dc99c5fb'
    ]
  },
  // 其他琐碎项
  other: {
    ehs: [
      '0', '0f82a21f-937f-4eae-ab60-eb12291c0636', 'f0d63ff8-857a-486d-8621-0ccc588398f6',
      '5581b45e-66e5-49b6-a49c-6d1f00ccc823', 'c5a1f724-cad5-44cc-98c7-e6f9ecb21d79',
      '105f66ea-099d-4490-915f-b926fb29b43f', '7a5130d1-3d7b-4855-8b3b-a18fa62d881b',
      'dde1eeb9-a0b7-4615-b35a-e2c7a19e66b4', '88473424-f1f7-4134-911c-7cac16f329f8',
      'df8009a1-3784-4642-93d5-99130430b0bd', '21397d2f-1669-4331-b53c-61c216cc4a5c',
      '03c92f6d-d103-462f-b461-097c33781dfb', 'f153c4fb-991f-4b36-a8d8-f339338d300a',
      'b847c890-f0a3-4673-b220-2bb343610696', '5f1759b1-76fb-4b56-8ddf-3e5deba766a1',
      '99188c5b-1fe8-406b-95cd-d0fd1556a15e', '969c911c-091e-458c-83cd-5f85e28d19b0',
      'b5b1b9ed-7903-4172-8ea6-a4e58cf24483', 'bde3a2fa-b129-4d8d-b5fc-3609016e5703',
      '9b9ccc1e-bc5c-4e3f-a3ee-a870bda87ec0', 'd6f844dd-d09a-48f0-a9cd-76f8d2c1ff62',
      '526a31f6-1dda-4055-8471-d82f0a93e581', '3c45a366-adc5-4d3a-b09c-a982d30a12f5',
      'e30ddbcf-7eff-4a5c-a09b-0991b7022680', 'f977aee9-e47f-4071-a622-b8244ce99e4f',
      '13d4d5ca-bb7a-4cac-a336-318bdcf3ac09', '93495ca7-9b2d-4c5b-9305-e1d108fbb1fa',
      '9a2d4f58-a117-425d-b7ef-d95a6c45ab38', 'dbf20f3b-f9f8-4539-b8c6-f158d3c63df3',
      '61c85cae-075b-49ad-ad8d-84d61174bb56', 'fcae4971-dfc0-4340-b446-cff272515e4a',
      '80aa0774-dba1-451f-8869-1290fc82f626', '8a3b39b1-9286-49c9-9daa-e35e6803bc05',
      '15920097-d20b-4ffe-a9fc-f80cdd5fda5b', '1ec6e634-fc94-49b1-bbc2-d43ae38b115c',
      '00abc9f5-1361-49c0-ba32-1623567140a8', '06a1b09a-4c33-46b1-b725-46a3e5162a44',
      'd8b777f5-f696-4aa3-8ebc-c3c99f1917a5', '8eadab38-60e2-4e16-bf4b-1f1ea307f098',
      'f5a75e1d-ef46-4fc9-8720-c6c8c3593421', '3c933e3b-7354-46c6-82c7-77d5f5a13b8b',
      'd31d8ce0-5ecd-4094-9063-73dfde61424d', '304766c7-c697-49b0-85db-d958536240ce',
      'c95185d1-7c94-420b-be6e-5a41571aaf73', '2c0cbbf0-c062-421f-9a8e-4a60faf06a02',
      'b5a773a5-f491-417c-a891-1faa0e00420f', 'e96c2d60-7c15-4ece-b7b9-4b6194957740',
      '8be2ada4-36f5-4403-b7ba-e019e3fabd77', '6faa96f0-856f-408c-ae89-a501cfef99a6',
      '4c22bd2c-8f38-4eb5-a874-60da6e24278c', '8121075b-8444-4039-8c97-21dbc77c5554',
      '09b33bda-542b-4c14-9aa0-228816b594bb', '2a59592c-7c64-4638-afef-dc0a3be0c83c',
      '828c74ec-4965-4a73-9457-b0fd860fd79e', 'bfe0b87b-4f50-438d-8a90-31f4c9836d8d',
      'a76b4e32-dc5c-4bae-a049-3ce059be9727', '46a40fc3-19e7-44b3-830a-652658c0b0fe',
      'cab78b94-665f-40b7-bb5e-a832e4bf381f', '0205c3e9-f1a7-4e33-b789-9a30fe74e1b3',
      'f2401147-8265-44a0-bad3-19853b88871b', '6f36f06b-0385-45a4-9c25-1566b5cf6cac',
      'eca6853b-4944-4e71-bf8f-cca8a33a702e', '2062c47d-aa71-4c87-86e1-b8974eaad547',
      'df607635-2d9f-42f2-a870-2d8400e4ee8b', '66c39304-b48e-477d-b407-7b04f2fefd5f',
      'dc627e3f-3341-4e6b-be18-82775ede9432', 'ca8ea227-4061-4bd3-a46d-46711c5186a4',
      'aef9004f-6aa2-4309-865c-a9b478bb90c4', 'c265aef9-dee3-4fe7-9a00-0ecf43f1d63f',
      '7743a006-685f-4ad5-9aae-019ba982b08d', 'caa5995b-a3f9-430e-b3d9-9376e480f366',
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', 'fcd017fd-a992-4bfb-842e-d4864ebaf518',
      '795f98a6-ec67-49ff-885c-985a6beea878', 'f5f4455f-ec8a-44f4-a0cd-586be77e6e90',
      'ce8f76ad-dfee-400e-a081-1d6b34879394', '9e06469a-839b-4a86-972a-0d207387b3ce',
      '5574ef61-3e50-4bb5-a25d-6093703d83f8', 'ea2e16a2-a0d9-4449-a3f8-5cdb840cf249',
      '82537ade-86c7-49ae-aec5-4d87967f9659', 'f5974994-bac6-446c-98ee-ea4d929cb516'
    ],
    yg: [
      '86de09c6-a6c4-4073-b0c6-c9b7f4bfc6e7', 'fcd017fd-a992-4bfb-842e-d4864ebaf518',
      '795f98a6-ec67-49ff-885c-985a6beea878', 'f5f4455f-ec8a-44f4-a0cd-586be77e6e90',
      'ce8f76ad-dfee-400e-a081-1d6b34879394', '9e06469a-839b-4a86-972a-0d207387b3ce',
      '5574ef61-3e50-4bb5-a25d-6093703d83f8', 'ea2e16a2-a0d9-4449-a3f8-5cdb840cf249',
      '82537ade-86c7-49ae-aec5-4d87967f9659', 'f5974994-bac6-446c-98ee-ea4d929cb516'
    ]
  }
}

/**
 * 模块选项与 MODULE_IDS 的 key 映射（按模块选择时的展示顺序）
 */
export const MODULE_OPTIONS = [
  { label: '隐患', key: 'hazard' },
  { label: '培训', key: 'train', conflict: ['trainNew'] },
  { label: '培训（新）', key: 'trainNew', conflict: ['train'] },
  { label: '作业', key: 'work', desc: '关联隐患、相关方、培训（新）' },
  { label: '巡检', key: 'inspect', desc: '关联隐患' },
  { label: '演练', key: 'drill' },
  { label: '事故', key: 'accident' },
  { label: '访客预约', key: 'visit', desc: '关联相关方、培训（新）' },
  { label: '查询中心', key: 'query' },
  { label: '其他琐碎项', key: 'other' }
]

/**
 * 组装模块 ID 传参
 * @param {string} plan all 全量开通 / custom 按模块选择
 * @param {string[]} selectedKeys 按模块选择时选中的模块 key 数组
 * @param {string} system ehs / yg
 * @returns {string[]} moduleIdList（去重，保持原有顺序）
 */
export function buildModuleIdList (plan, selectedKeys, system) {
  const sys = system === 'yg' ? 'yg' : 'ehs'
  if (plan === 'all') {
    return [...MODULE_IDS.all[sys]]
  }
  const ids = []
    ; (selectedKeys || []).forEach(key => {
    const list = MODULE_IDS[key] ? MODULE_IDS[key][sys] : []
    list.forEach(id => {
      if (!ids.includes(id)) ids.push(id)
    })
  })
  return ids
}

/**
 * 组装初始化租户菜单 ID 传参（EHS 管理员与 YG 员工两套同时返回）
 * @param {string} plan all 全量开通 / custom 按模块选择
 * @param {string[]} selectedKeys 按模块选择时选中的模块 key 数组
 * @returns {{ehsMenuIds: string[], ygMenuIds: string[]}} 各自去重并保持原有顺序
 */
export function buildMenuIds (plan, selectedKeys) {
  return {
    ehsMenuIds: buildModuleIdList(plan, selectedKeys, 'ehs'),
    ygMenuIds: buildModuleIdList(plan, selectedKeys, 'yg')
  }
}
